import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import { i18n } from 'vue-lang-router'
import VueGtag from "vue-gtag"
import store from './store'

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: {id: 'G-Z2EXYE43H4'}
})

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
